import { isAskaFlow, isCitizinsFlow } from '../utils/globalVariables';
import useIsNLplan from './useIsNLPlan';

interface LanguageOption {
  value: string;
  label: string;
  locale?: string;
}

export const allLanguageOptions = [
  {
    value: 'nl',
    label: 'Nederlands',
  },
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'fr',
    label: 'Français',
  },
  {
    value: 'de',
    label: 'Deutsch',
  },
  {
    value: 'es',
    label: 'Español',
  },
];

const useLanguageOptions = (): LanguageOption[] => {
  const { isNL } = useIsNLplan();

  const baseLanguages = [
    {
      value: 'nl',
      label: 'Nederlands',
    },
    {
      value: 'en',
      label: 'English',
    },
    {
      value: 'fr',
      label: 'Français',
    },
    {
      value: 'de',
      label: 'Deutsch',
    },
  ];

  if (isCitizinsFlow()) {
    return [
      ...baseLanguages,
      {
        value: 'es',
        label: 'Español',
      },
    ];
  }

  if (isNL || isAskaFlow())
    return [
      {
        value: 'nl',
        locale: 'nl-NL',
        label: 'Nederlands',
      },
      {
        value: 'en',
        label: 'English',
      },
    ];

  return baseLanguages;
};

export default useLanguageOptions;
